import { Controller } from '@hotwired/stimulus';

// Asks for confirmation in a <dialog> before sending a DELETE request, or before submitting the
// surrounding form when no url is given
export default class extends Controller {
    static targets = ['dialog', 'error', 'confirm', 'cancel'];
    static values = { url: String, redirectUrl: String };

    connect() {
        // Back from the next page can restore this page with the dialog still open and busy
        this.reset = () => {
            this.close();
            this.setIsBusy(false);
        };
        window.addEventListener('pageshow', this.reset);
    }

    disconnect() {
        window.removeEventListener('pageshow', this.reset);
    }

    open(event) {
        event.preventDefault();
        this.errorTarget.hidden = true;
        this.setIsBusy(false);
        this.dialogTarget.showModal();
    }

    close() {
        this.dialogTarget.close();
    }

    async confirm() {
        if ('' === this.urlValue) {
            this.submitForm();

            return;
        }
        this.setIsBusy(true);
        try {
            const response = await fetch(this.urlValue, { method: 'DELETE', headers: { Accept: 'application/json' } });
            if (204 !== response.status) {
                throw new Error(`Delete failed with status ${response.status}`);
            }
            if ('' !== this.redirectUrlValue) {
                window.location.href = this.redirectUrlValue;

                return;
            }
            this.dialogTarget.close();
            this.element.closest('[data-confirm-delete-remove]')?.remove();
        } catch {
            this.errorTarget.hidden = false;
        }
        this.setIsBusy(false);
    }

    submitForm() {
        const form = this.element.closest('form');
        if (null === form) {
            throw new Error('confirm-delete needs a url or a surrounding form');
        }
        // The browser can only point out an invalid field once the modal dialog is gone
        if (!form.checkValidity()) {
            this.close();
            form.reportValidity();

            return;
        }

        // Busy only once the submit really goes ahead
        const markBusy = () => this.setIsBusy(true);
        form.addEventListener('submit', markBusy, { once: true });
        form.requestSubmit();
        form.removeEventListener('submit', markBusy);
    }

    setIsBusy(isBusy) {
        this.confirmTarget.disabled = isBusy;
        this.cancelTarget.disabled = isBusy;
    }
}
